const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);
const LOCAL_TENANT = process.env.REACT_APP_LOCAL_TENANT || 'root-test-tenant';

export function resolveTenantId(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  if (!hostname) return null;
  if (LOCAL_HOSTS.has(hostname)) return LOCAL_TENANT;
  return hostname.replace(/\./g, '-');
}

export const tenantId = resolveTenantId();
